import ResetPasswordForm from "./reset-password-form";

export default ResetPasswordForm;
